import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import cx from "classnames";
import styles from "./successNotification.module.scss";
import { hideNotification } from "../../../../store/notification/notificationActions";
import { CloseIcon, IconGroup } from "@gataca/design-system/web";
import { gaColors } from "../../../../assets/globalConstants";

type ISuccessNotificationProps = {
  title: string;
  label: string;
  closeButton?: boolean;
  className?: string;
};

const SuccessNotification: React.FC<ISuccessNotificationProps> = (props) => {
  const { title, label, closeButton, className } = props;
  const dispatch = useDispatch();

  useEffect(() => {}, [label]);

  const closeNotification = () => dispatch(hideNotification());

  return (
    <div
      className={`${styles.successNotification} ${className ? className : ""}`}>
      <div className={styles.successNotification__content}>
        <div
          className={`${closeButton ? "" : styles.fullWidth} ${
            styles.successNotification__content__texts
          }`}>
          {title ? (
            <p
              className={`${closeButton ? "" : styles.fullWidth} ${
                styles.title
              } ${cx("bodyBoldSM neutral1000")}`}>
              {title}
            </p>
          ) : null}
          {label && <p className={styles.label}>{label}</p>}
        </div>
        {closeButton && (
          <IconGroup
            className={styles.successNotification__content__close}
            iconList={[
              {
                Icon: CloseIcon,
                color: gaColors?.success300,
                size: "24",
                onClick: closeButton ? () => closeNotification() : undefined,
              },
            ]}
          />
        )}
      </div>
    </div>
  );
};

export default SuccessNotification;
